module.exports = __webpack_public_path__ + "static/img/day2.ee61e83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/day2.jpg
// module id = PMv4
// module chunks = 0